import { takeLatest, put, delay } from 'redux-saga/effects'
import {
  KurentoConnectionStateActionType,
  SET_KURENTO_CONNECTION_STATE,
  SET_KURENTO_MOUNTED
} from '../redux/kurentoReducer'

function* ResetKurentoFlow(action: KurentoConnectionStateActionType): Generator<any, void, any> {
  try {
    if (
      action.payload.connectionState === 'disconnected' ||
      action.payload.connectionState === 'failed' ||
      action.payload.connectionState === 'closed'
    ) {
      yield put(SET_KURENTO_MOUNTED(false))
    }
    yield delay(1000)
    yield put(SET_KURENTO_MOUNTED(true))
  } catch (error) {
    console.log(error)
  }
}

export default function* ResetKurentoSaga(): Generator<any, void, any> {
  yield takeLatest([SET_KURENTO_CONNECTION_STATE], ResetKurentoFlow)
}
